<template>
  <div class="logorow">
    <img src="../assets/img/logo.png" class="img-fluid" />
  </div>
</template>

<script>
export default {
  name: "Logo",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },

  mounted() {}
};
</script>

<style>
.logorow{
  height: 100vh;
      margin: 0px;
    background: #0e0e0e;
}

.logorow img{
  position: fixed;
      left: 40%;
    top: 40%;


}
</style>



// WEBPACK FOOTER //
// src/components/logo.vue